import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';

const ClientDashboardSelectors = (state: RootState) => state.clientDashboard;

export const selectClientDashboardPageTitle = createSelector(
  ClientDashboardSelectors,
  (state) => state.pageTitles[state.currentComponentIndex],
);

export const selectClientDashboardCurrentIndex = createSelector(
  ClientDashboardSelectors,
  (state) => state.currentComponentIndex,
);
